import Script from 'next/script'

interface StructuredDataProps {
  type:
    | 'Organization'
    | 'WebApplication'
    | 'WebSite'
    | 'BreadcrumbList'
    | 'FAQPage'
  data: any
}

export function StructuredData({ type, data }: StructuredDataProps) {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  }

  return (
    <Script
      id={`structured-data-${type.toLowerCase()}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
  )
}

// Predefined structured data components
export function OrganizationStructuredData() {
  return (
    <StructuredData
      type="Organization"
      data={{
        name: 'Wagamour',
        url: 'https://wagamour.com',
        logo: 'https://wagamour.com/assets/favicon-v2.png',
        sameAs: [
          'https://www.instagram.com/wagamourapp',
          'https://www.linkedin.com/company/wagamour',
        ],
      }}
    />
  )
}

export function WebApplicationStructuredData() {
  return (
    <StructuredData
      type="WebApplication"
      data={{
        name: 'Wagamour',
        operatingSystem: 'iOS, Android',
        applicationCategory: 'LifestyleApplication',
        description:
          'Wagamour is an AI-powered pet mobility app that helps dog parents plan smarter walks, stay safe in changing conditions, and discover personalized gear recommendations.',
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'USD',
        },
        publisher: {
          '@type': 'Organization',
          name: 'Wagamour',
        },
      }}
    />
  )
}

export function WebSiteStructuredData() {
  return (
    <StructuredData
      type="WebSite"
      data={{
        url: 'https://wagamour.com',
        name: 'Wagamour',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://wagamour.com/?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }}
    />
  )
}

export function BreadcrumbStructuredData({
  items,
}: {
  items: Array<{ name: string; url: string }>
}) {
  return (
    <StructuredData
      type="BreadcrumbList"
      data={{
        itemListElement: items.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          item: item.url,
        })),
      }}
    />
  )
}

export function FAQStructuredData({
  faqs,
}: {
  faqs: Array<{ question: string; answer: string }>
}) {
  return (
    <StructuredData
      type="FAQPage"
      data={{
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      }}
    />
  )
}
